import { render } from "./potatoNew.vue?vue&type=template&id=4b102411&scoped=true"
import script from "./potatoNew.vue?vue&type=script&lang=js"
export * from "./potatoNew.vue?vue&type=script&lang=js"

import "./potatoNew.vue?vue&type=style&index=0&id=4b102411&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b102411"]])

export default __exports__